import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGulpComponent } from './simple-icons-gulp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGulpComponent ],
    exports:      [ SimpleIconsGulpComponent ],
    bootstrap:    []
})
export class SimpleIconsGulpModule {}
